import { Tooltip } from "react-tooltip";
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ModeCommentOutlinedIcon from '@mui/icons-material/ModeCommentRounded';
import SendIcon from '@mui/icons-material/SendRounded';
import { useContext, useState } from "react";
import { FormContext } from "../../../context/FormContext";

function ShareForm() {
  

  return (
    <>
      <div className="contents-main">
        <h1 style={{ marginBottom: 8 }}>The social cost.</h1>

        <p>
          The World Happiness report shows Instagram use lowers user happiness by around 0.1 points on a 10-point scale.
          <br></br>
          <br></br>
          Economists estimate it takes around <b>$15,000 in income</b> to raise happiness by one full point, meaning a 0.1 point loss equals <b>$1,500 a year</b>.
          <br></br>
          <br></br>
          Over the average Instagram account age, that's <b>$6,000</b> in lost wellbeing.
          <br></br>
          <br></br>
          We include this flat fee on every invoice.
        </p>

      </div>

      <div className="contents-footer">
        <p className="footer-label">Your Wellbeing Damages</p>
        <p className="footer-value">$6,000</p>
      </div>
    </>
  );
}
export default ShareForm;
